import { useEffect, useState } from "react"
import { BasicButton } from "../../../../../theme/Component/BasicButton"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { _AccountINFORPO } from "../../../../../../core/services/dataBean/EntityCatalog"
import { ObjectDinamicViewer } from "../../../../../contract/etapa-contrato/contrac/ublinvoice/FireElectronicDocument/ObjectDinamicViewer/ObjectDinamicViewer"
import { toast } from "react-toastify"

interface Props {
    Affiliate?: any;
    onChange?: Function;
}

export const SelectCodeudor = ({ Affiliate, onChange }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_AccountINFORPO)

    useEffect(() => {
        console.log(Affiliate.Nit)
        if (Affiliate?.Nit) {
            getAffiliate(Affiliate?.Nit)
        }
    }, [Affiliate])

    const getAffiliate = (nit?: number) => {
        setBean({})
        instance.searchCreditAffiliateByNit(nit ?? parseInt(filter.Nit)).then(
            (resp) => {
                setBean(resp)
            }
        ).catch(
            err => {
                console.log(err)
            }
        )
    }

    const [filter, setFilter] = useState<any>({});

    const limpiar = () => {
        setFilter({ Nit: null, Name: null, Surname: null });
    }


    const head = [
        { title: 'Identificacion', property: 'Nit', visible: true },
        { title: 'Fecha de Nacimiento', property: 'FechaNacimiento', visible: true },
        { title: 'Nombres', property: 'Entityname', visible: true },
        { title: 'Numero de Celular', property: 'NumeroCelular', visible: true },
    ]

    const retunrData = () => {
        if (bean.IDAccount) {
            onChange?.(bean)
        } else {
            toast.error("Usuario no Valido")
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="row">
                    <div className="col-md">
                        <div className="input-group">
                            <input placeholder='Identificación' type="text" name="identificacion" id="Identificacion"
                                className='form-control text-uppercase' value={filter.Nit ?? undefined} onChange={(e) => { setFilter({ ...filter, "Nit": e.target.value }) }} />
                            <button className="btn btn-success" type="button" onClick={() => {
                                getAffiliate();
                            }}>Buscar</button>
                            <button className="btn btn-danger" type="button" onClick={limpiar}>Limpiar</button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col mt-4">
                        <ObjectDinamicViewer data={bean} head={head} />
                    </div>
                </div>
                <BasicButton eventClick={retunrData} icon="ri-save-line" children={`Guardar`} />
            </div>
        </div>
    )
}